/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AnalyticsStepType,
    AnalyticsStepTypeFromJSON,
    AnalyticsStepTypeFromJSONTyped,
    AnalyticsStepTypeToJSON,
} from './AnalyticsStepType';
import {
    DateMacro,
    DateMacroFromJSON,
    DateMacroFromJSONTyped,
    DateMacroToJSON,
} from './DateMacro';
import {
    NumberBarPoint,
    NumberBarPointFromJSON,
    NumberBarPointFromJSONTyped,
    NumberBarPointToJSON,
} from './NumberBarPoint';
import {
    NumberSeriesPoint,
    NumberSeriesPointFromJSON,
    NumberSeriesPointFromJSONTyped,
    NumberSeriesPointToJSON,
} from './NumberSeriesPoint';
import {
    ShortLinkAnalyticsObjectType,
    ShortLinkAnalyticsObjectTypeFromJSON,
    ShortLinkAnalyticsObjectTypeFromJSONTyped,
    ShortLinkAnalyticsObjectTypeToJSON,
} from './ShortLinkAnalyticsObjectType';

/**
 * 
 * @export
 * @interface ShortLinkAnalytics
 */
export interface ShortLinkAnalytics {
    /**
     * 
     * @type {string}
     * @memberof ShortLinkAnalytics
     */
    id?: string;
    /**
     * 
     * @type {ShortLinkAnalyticsObjectType}
     * @memberof ShortLinkAnalytics
     */
    object: ShortLinkAnalyticsObjectType;
    /**
     * 
     * @type {string}
     * @memberof ShortLinkAnalytics
     */
    program_id: string;
    /**
     * 
     * @type {string}
     * @memberof ShortLinkAnalytics
     */
    campaign_id?: string;
    /**
     * 
     * @type {DateMacro}
     * @memberof ShortLinkAnalytics
     */
    date_macro: DateMacro;
    /**
     * 
     * @type {AnalyticsStepType}
     * @memberof ShortLinkAnalytics
     */
    unit: AnalyticsStepType;
    /**
     * 
     * @type {Date}
     * @memberof ShortLinkAnalytics
     */
    start_date: Date;
    /**
     * 
     * @type {Date}
     * @memberof ShortLinkAnalytics
     */
    end_date: Date;
    /**
     * 
     * @type {Array<NumberSeriesPoint>}
     * @memberof ShortLinkAnalytics
     */
    total_clicks: Array<NumberSeriesPoint>;
    /**
     * 
     * @type {Array<NumberSeriesPoint>}
     * @memberof ShortLinkAnalytics
     */
    total_unique_clicks: Array<NumberSeriesPoint>;
    /**
     * 
     * @type {Array<NumberSeriesPoint>}
     * @memberof ShortLinkAnalytics
     */
    total_scans: Array<NumberSeriesPoint>;
    /**
     * 
     * @type {Array<NumberSeriesPoint>}
     * @memberof ShortLinkAnalytics
     */
    total_unique_scans: Array<NumberSeriesPoint>;
    /**
     * 
     * @type {Array<NumberBarPoint>}
     * @memberof ShortLinkAnalytics
     */
    referrers: Array<NumberBarPoint>;
    /**
     * 
     * @type {Array<NumberBarPoint>}
     * @memberof ShortLinkAnalytics
     */
    unique_referrers: Array<NumberBarPoint>;
    /**
     * 
     * @type {Array<NumberBarPoint>}
     * @memberof ShortLinkAnalytics
     */
    countries: Array<NumberBarPoint>;
    /**
     * 
     * @type {Array<NumberBarPoint>}
     * @memberof ShortLinkAnalytics
     */
    unique_countries: Array<NumberBarPoint>;
    /**
     * 
     * @type {Array<NumberBarPoint>}
     * @memberof ShortLinkAnalytics
     */
    operating_systems: Array<NumberBarPoint>;
    /**
     * 
     * @type {Array<NumberBarPoint>}
     * @memberof ShortLinkAnalytics
     */
    unique_operating_systems: Array<NumberBarPoint>;
    /**
     * 
     * @type {Array<NumberBarPoint>}
     * @memberof ShortLinkAnalytics
     */
    browsers: Array<NumberBarPoint>;
    /**
     * 
     * @type {Array<NumberBarPoint>}
     * @memberof ShortLinkAnalytics
     */
    unique_browsers: Array<NumberBarPoint>;
}

export function ShortLinkAnalyticsFromJSON(json: any): ShortLinkAnalytics {
    return ShortLinkAnalyticsFromJSONTyped(json, false);
}

export function ShortLinkAnalyticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShortLinkAnalytics {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'object': ShortLinkAnalyticsObjectTypeFromJSON(json['object']),
        'program_id': json['program_id'],
        'campaign_id': !exists(json, 'campaign_id') ? undefined : json['campaign_id'],
        'date_macro': DateMacroFromJSON(json['date_macro']),
        'unit': AnalyticsStepTypeFromJSON(json['unit']),
        'start_date': (new Date(json['start_date'])),
        'end_date': (new Date(json['end_date'])),
        'total_clicks': ((json['total_clicks'] as Array<any>).map(NumberSeriesPointFromJSON)),
        'total_unique_clicks': ((json['total_unique_clicks'] as Array<any>).map(NumberSeriesPointFromJSON)),
        'total_scans': ((json['total_scans'] as Array<any>).map(NumberSeriesPointFromJSON)),
        'total_unique_scans': ((json['total_unique_scans'] as Array<any>).map(NumberSeriesPointFromJSON)),
        'referrers': ((json['referrers'] as Array<any>).map(NumberBarPointFromJSON)),
        'unique_referrers': ((json['unique_referrers'] as Array<any>).map(NumberBarPointFromJSON)),
        'countries': ((json['countries'] as Array<any>).map(NumberBarPointFromJSON)),
        'unique_countries': ((json['unique_countries'] as Array<any>).map(NumberBarPointFromJSON)),
        'operating_systems': ((json['operating_systems'] as Array<any>).map(NumberBarPointFromJSON)),
        'unique_operating_systems': ((json['unique_operating_systems'] as Array<any>).map(NumberBarPointFromJSON)),
        'browsers': ((json['browsers'] as Array<any>).map(NumberBarPointFromJSON)),
        'unique_browsers': ((json['unique_browsers'] as Array<any>).map(NumberBarPointFromJSON)),
    };
}

export function ShortLinkAnalyticsToJSON(value?: ShortLinkAnalytics | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'object': ShortLinkAnalyticsObjectTypeToJSON(value.object),
        'program_id': value.program_id,
        'campaign_id': value.campaign_id,
        'date_macro': DateMacroToJSON(value.date_macro),
        'unit': AnalyticsStepTypeToJSON(value.unit),
        'start_date': (value.start_date.toISOString()),
        'end_date': (value.end_date.toISOString()),
        'total_clicks': ((value.total_clicks as Array<any>).map(NumberSeriesPointToJSON)),
        'total_unique_clicks': ((value.total_unique_clicks as Array<any>).map(NumberSeriesPointToJSON)),
        'total_scans': ((value.total_scans as Array<any>).map(NumberSeriesPointToJSON)),
        'total_unique_scans': ((value.total_unique_scans as Array<any>).map(NumberSeriesPointToJSON)),
        'referrers': ((value.referrers as Array<any>).map(NumberBarPointToJSON)),
        'unique_referrers': ((value.unique_referrers as Array<any>).map(NumberBarPointToJSON)),
        'countries': ((value.countries as Array<any>).map(NumberBarPointToJSON)),
        'unique_countries': ((value.unique_countries as Array<any>).map(NumberBarPointToJSON)),
        'operating_systems': ((value.operating_systems as Array<any>).map(NumberBarPointToJSON)),
        'unique_operating_systems': ((value.unique_operating_systems as Array<any>).map(NumberBarPointToJSON)),
        'browsers': ((value.browsers as Array<any>).map(NumberBarPointToJSON)),
        'unique_browsers': ((value.unique_browsers as Array<any>).map(NumberBarPointToJSON)),
    };
}

